var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdmin = function SvgAdmin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB70C",
    fillRule: "evenodd",
    d: "M8.431 14.312a1.04 1.04 0 0 0-.862 0l-1.307.594c-.52.236-1.131.011-1.38-.508l-.585-1.224a1.06 1.06 0 0 0-.686-.568l-1.334-.347a1.067 1.067 0 0 1-.752-1.32l.338-1.224a1.08 1.08 0 0 0-.164-.915L.952 7.763a1.074 1.074 0 0 1 .264-1.513l1.092-.744c.263-.179.432-.468.46-.788l.117-1.298a1.057 1.057 0 0 1 1.137-.966l1.419.122c.302.026.6-.082.819-.294l1.01-.984a1.044 1.044 0 0 1 1.46 0l1.01.984c.219.212.517.32.819.294l1.419-.122a1.057 1.057 0 0 1 1.137.966l.116 1.298c.029.32.198.61.461.788l1.092.744c.496.337.616 1.024.264 1.513L14.3 8.8c-.19.263-.25.6-.164.915l.338 1.225c.159.575-.18 1.17-.752 1.32l-1.334.346c-.3.078-.55.286-.686.568l-.586 1.225c-.248.518-.859.743-1.379.507z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.5 6.542 10.464 5.5 7.069 8.915 5.536 7.373 4.5 8.416 7.069 11z",
    clipRule: "evenodd"
  })));
};
export default SvgAdmin;